import React, { useEffect, useState } from "react";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-google-places-autocomplete";
import { GoogleAPI } from "../../utils/keys";

interface LocationInputProps {
  value?: any;
  setValue?: (value: any) => void;
  setCenter?: (value: { latitude: number; longitude: number }) => void;
  placeholder?: string;
  height?: number;
  setSuggestions?: (places: string[]) => void; // For dynamic suggestions
  setCity?: (city: string) => void; // For city
  setCountry?: (country: string) => void; // For country
}

const LocationFinder: React.FC<LocationInputProps> = ({
  value,
  setValue,
  setCenter,
  placeholder = "Search for a location",
  height = 40,
  setSuggestions,
  setCity,
  setCountry,
}) => {
  const handleChange = (suggestion: any) => {
    if (setValue) setValue(suggestion);

    geocodeByAddress(suggestion.label)
      .then((results) => {
        const addressComponents = results[0].address_components;

        const city = addressComponents.find(
          (comp) =>
            comp.types.includes("locality") ||
            comp.types.includes("administrative_area_level_2")
        )?.long_name;

        const country = addressComponents.find((comp) =>
          comp.types.includes("country")
        )?.long_name;

        console.log("Extracted City:", city);
        console.log("Extracted Country:", country);

        // Ensure city and country are set correctly
        if (setCity && city) setCity(city);
        if (setCountry && country) setCountry(country);

        getLatLng(results[0]).then(({ lat, lng }) => {
          if (setCenter) {
            setCenter({
              latitude: lat,
              longitude: lng,
            });
          }
        });
      })
      .catch((error) =>
        console.error("Error fetching location details:", error)
      );
  };

  // Fetch user's current location
  useEffect(() => {
    if (!setSuggestions) return;

    const fetchCurrentLocationSuggestions = async () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const { latitude, longitude } = position.coords;

            // Fetch nearby places using Google Places API
            try {
              const response = await fetch(
                `https://maps.googleapis.com/maps/api/place/nearbysearch/json?location=${latitude},${longitude}&radius=5000&type=point_of_interest&key=${GoogleAPI}`
              );

              const data = await response.json();
              console.log("Nearby Places Response:", data); // Debug fetched data
              if (data.results) {
                const places = data.results.map((place: any) => place.name); // Extract place names
                setSuggestions(places); // Update suggestions state
              } else {
                console.warn("No results found for nearby places.");
              }
            } catch (error) {
              console.error("Error fetching nearby places:", error);
            }
          },
          (error) => {
            console.error("Error fetching location:", error);
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    };

    fetchCurrentLocationSuggestions();
  }, [setSuggestions]);

  return (
    <div>
      <GooglePlacesAutocomplete
        apiKey={GoogleAPI}
        selectProps={{
          value,
          onChange: handleChange,
          placeholder,
          styles: {
            input: (provided) => ({
              ...provided,
              height,
            }),
          },
        }}
      />
    </div>
  );
};

export default LocationFinder;
